import { useLayoutContext } from '@/context/LayoutContext';
import React, { useState } from 'react';
import StepperService from './StepperService';
import styles from './styles.module.css';
import ServiceList from './ServiceList';
import { useTranslations } from 'next-intl';
import Button from '@/components/common/Button';
import MainIcons from '@/icons/main';
import WeekSelector from './WeekSelector';
import TimeSlots from './TimeSlots';
import ReservePaymentLevel from './ReservePaymentLevel';
import ReserveSectionHead from './ReserveSectionHead';
import { ReserveInfo } from '@/commonTypes';
import AppointmentSummary from './AppointmentSummary';
import { TRIGGERS } from '@/api/global';
// import WeekSelector from './WeekSelector';

export default function ServiceReserveModal({
  className = '',
  reserveContent = '',
  timeSlotClass = '',
  page = '',
  children,
}) {
  const { editInfo, setEditInfo, setTrigger } = useLayoutContext();
  const tCommon = useTranslations('common');
  const empty: ReserveInfo = {
    service: null,
    date: '',
    time: '',
    location: '',
    paymentMethod: '',
    error: {
      service: false,
      date: false,
      time: false,
      location: false,
      paymentMethod: false,
      //   country: false,
    },
    messages: {
      service: tCommon('requiredField'),
      date: tCommon('requiredField'),
      time: tCommon('requiredField'),
      location: tCommon('requiredField'),
      paymentMethod: tCommon('requiredField'),
      //   country: tCommon('requiredField'),
    },
  };
  const [info, setInfo] = useState<ReserveInfo>(empty);
  const steps = [
    editInfo?.type == 'shop'
      ? {
          title: 'خدمت',
          id: 1,
        }
      : null,
    {
      title: 'زمان',
      id: 2,
    },
    {
      title: 'پرداخت',
      id: 3,
    },
  ];
  const sendFunction = () => {
    const check = checkError();
    if (!check) {
      if (editInfo?.level < 3) {
        setEditInfo({ ...editInfo, level: editInfo?.level + 1 });
      } else {
        if (page != 'service') {
          setEditInfo(null);
        } else {
          setEditInfo({ ...editInfo, level: 2 });
        }
        setTrigger(TRIGGERS.EMPTY);
        setInfo(empty);
      }
    }
  };
  const onChange = (value: any, key: string) => {
    let valueIs = {
      [key]: value,
      error: {
        ...info?.error,
        [key]: false,
      },
    };
    let dummy: ReserveInfo = { messages: empty.messages, error: empty.error };

    if (key == 'service') {
      dummy = { ...empty, ...valueIs };
    } else if (key == 'date') {
      dummy = { ...info, ...valueIs, time: '' };
    } else {
      dummy = { ...info, ...valueIs };
    }

    setInfo({ ...dummy });
  };
  const checkError = () => {
    const dummy = { ...info };

    let result = false;
    const level1Fields: Array<keyof Pick<ReserveInfo, 'service'>> = ['service'];
    const stringFields: Array<keyof Pick<ReserveInfo, 'date' | 'time'>> = ['date', 'time'];

    const numberFields: Array<keyof Pick<ReserveInfo, 'location' | 'paymentMethod'>> = [
      'location',
      'paymentMethod',
    ];
    if (editInfo?.level == 1) {
      level1Fields.forEach((field) => {
        const value = info[field];

        const isEmpty = value === null || value === undefined;
        if (dummy.error) {
          dummy.error[field] = isEmpty;
          if (isEmpty) result = true;
        }
      });
    }
    if (editInfo?.level == 2) {
      stringFields.forEach((field) => {
        const isEmpty = !String(info[field] ?? '').trim();
        if (dummy.error) {
          dummy.error[field] = isEmpty;
          if (isEmpty) result = true;
        }
      });
    }
    if (editInfo?.level == 3) {
      numberFields.forEach((field) => {
        const value = info[field];

        const isEmpty = value === '' || value === null || value === undefined;
        if (dummy.error) {
          dummy.error[field] = isEmpty;
          if (isEmpty) result = true;
        }
      });
    }
    setInfo(dummy);
    return result;
  };

  const timeSlots = [
    { id: 1, time: '۰۹:۰۰', state: 'disabled' },
    { id: 2, time: '۱۰:۰۰', state: 'disabled' },
    { id: 3, time: '۱۱:۰۰', state: 'disabled' },
    { id: 4, time: '۱۲:۰۰', state: 'disabled' },
    { id: 5, time: '۱۴:۰۰', state: 'available' },
    { id: 6, time: '۱۵:۰۰', state: 'available' },
    { id: 7, time: '۱۶:۰۰', state: 'available' },
    { id: 8, time: '۱۷:۰۰', state: 'available' },
    { id: 9, time: '۱۸:۰۰', state: 'available' },
    { id: 10, time: '۱۹:۰۰', state: 'available' },
  ];

  console.log('info========', info, editInfo);
  return (
    <div className={`${styles.container} ${className}`}>
      {children && <div className={`${styles.reserveContent}`}>{children}</div>}
      <StepperService steps={steps} active={editInfo?.level} />
      <div className={`${styles.reserveContent} ${reserveContent}`}>
        {editInfo?.level == 1 && (
          <ServiceList
            services={editInfo?.item?.services}
            onClick={(value) => onChange(value, 'service')}
            active={info?.service?.id}
            info={info}
          />
        )}
        {editInfo?.level == 2 && (
          <>
            <ReserveSectionHead title={`انتخاب روز`} />
            <WeekSelector onChange={onChange} info={info} />
            <ReserveSectionHead title={`ساعت‌های خالی`} emptyTimesInfo={true} />
            <TimeSlots
              onChange={onChange}
              info={info}
              setInfo={setInfo}
              timeSlots={timeSlots}
              className={timeSlotClass}
            />
          </>
        )}

        {editInfo?.level == 3 && (
          <>
            <ReservePaymentLevel info={info} onChange={onChange} timeSlots={timeSlots} />
          </>
        )}
      </div>
      <div className={`${styles.buttonContainer}`}>
        {((editInfo?.type == 'shop' && editInfo?.level > 1) ||
          (editInfo?.type == 'service' && editInfo?.level > 2)) && (
          <Button
            className={`btn btn-white squareButton noBoxShadow`}
            onClick={() => {
              setEditInfo({ ...editInfo, level: editInfo?.level - 1 });
            }}
          >
            قبلی
          </Button>
        )}
        <Button className={`btn btn-primary squareButton noBoxShadow`} onClick={sendFunction}>
          {editInfo?.level == 1 ? 'ادامه' : 'تایید و ثبت نوبت'}
          <MainIcons.arrowIcon className={`rotateIcon-rtl`} fill="var(--paper)" />
        </Button>
      </div>
    </div>
  );
}
